import React, { useMemo } from 'react'
import ReactEcharts from "echarts-for-react";
import styles from './survey-answers.module.css'
import moment from 'moment';

const tooltipFormatter = (data, config) => {
    const date = moment(data.name)
    if (config.date) {
        return `${date.format(config.hour ? 'L LT' : 'L')} : ${data.value[1]}`
    } else if (config.hour) {
        return `${date.format('LT')} : ${data.value[1]}`
    }
}

const DateAnswers = (props) => {
    const { question } = props;
    const { name, order, data, config } = question;

    const option = useMemo(() => {
        let graphData = [];

        if (config.date) {
            graphData = data.map(item => {
                const d = moment(item.textValue)
                return {
                    name: d.format(),
                    value: [
                        +d.toDate(),
                        item.count
                    ]
                }
            })
        } else if (config.hour) {
            const today = moment().format('YYYY-MM-DD')
            graphData = data.map(item => {
                const d = moment(`${today} ${item.textValue}`)
                return {
                    name: d.format(),
                    value: [
                        +d.toDate(),
                        item.count
                    ]
                }
            })
        }

        const option = {
            grid: { right: 10, top: 10 },
            xAxis: { type: 'time' },
            yAxis: { type: 'value' },
            series: [
                {
                    name: 'Date answers',
                    data: graphData,
                    type: 'line'
                }
            ],
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    params = params[0];
                    return tooltipFormatter(params, config)
                },
                axisPointer: {
                    animation: false
                }
            },
            dataZoom: [
                {
                    type: 'inside',
                    orient: 'horizontal',
                    start: 0,
                    end: 100,
                    minSpan: 10,
                },
                {
                    type: 'slider',
                    show: true,
                }
            ],
        };
        return option;
    }, [data, config])

    return (
        <>
            <p className={styles['question-title']}>{order}. {name}</p>
            {
                (!data || data.length === 0)
                    ? <p>N/D</p>
                    : <ReactEcharts option={option} />
            }
        </>
    )
}

export default DateAnswers